import create from '../utils/create';
import { functionalRoute } from '../utils/router';
export default create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c(_vm.tag, {
      tag: "component",
      class: _vm.b([_vm.type, _vm.size, {
        gradients: _vm.gradients,
        weaken: _vm.weaken,
        block: _vm.block,
        plain: _vm.plain,
        round: _vm.round,
        square: _vm.square,
        loading: _vm.loading,
        disabled: _vm.disabled,
        unclickable: _vm.disabled || _vm.loading,
        'bottom-action': _vm.bottomAction,
        'fixed-in-bottom': _vm.fixedInBottom
      }]),
      attrs: {
        "type": _vm.nativeType,
        "disabled": _vm.disabled
      },
      on: {
        "click": _vm.onClick
      }
    }, [_vm.loading ? _c('loading', {
      attrs: {
        "color": _vm.weaken || _vm.plain ? '#ff9645' : '#fff',
        "type": 'pointloading',
        "size": '46px'
      }
    }) : _c('span', {
      class: _vm.b('text')
    }, [_vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2)], 1);
  },
  name: 'button',
  props: {
    text: String,
    block: Boolean,
    plain: Boolean,
    round: Boolean,
    square: Boolean,
    loading: Boolean,
    disabled: Boolean,
    nativeType: String,
    bottomAction: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'default'
    },
    size: {
      type: String,
      default: 'normal'
    },
    gradients: Boolean,
    weaken: Boolean,
    fixedInBottom: Boolean,
    url: String,
    replace: Boolean,
    to: [String, Object]
  },
  methods: {
    onClick: function onClick(event) {
      if (!this.loading && !this.disabled) {
        this.$emit('click', event);
        functionalRoute(this);
      }
    }
  }
});